/**
 * New stock adjustment route — mounts `<StockAdjustmentComposerPage />`.
 *
 * @see apps/web/src/features/inventory/stock/stock-adjustments-page.tsx
 */
import { createFileRoute } from "@tanstack/react-router";
import { StockAdjustmentComposerPage } from "../../../../features/inventory/index.ts";
import { WorkspaceShell } from "../../../../features/workspace/index.ts";

export const Route = createFileRoute("/(workspace)/inventory/stock-adjustments/new")({
  component: NewStockAdjustmentRoute,
});

function NewStockAdjustmentRoute() {
  return (
    <WorkspaceShell
      breadcrumbs={[
        { label: "Inventory", to: "/" },
        { label: "Adjustments", to: "/inventory/stock-adjustments" },
        { label: "New adjustment" },
      ]}
      viewportClassName="p-0"
      contentClassName="max-w-none h-full"
      disableViewportScroll
    >
      <StockAdjustmentComposerPage />
    </WorkspaceShell>
  );
}
